import product from './modules/product'
import budget from './modules/budget'
import city from './modules/city'

export default {
  product,
  budget,
  city,
}
